export default {"src":"/_next/static/media/3physio.4c34ae02.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};